import React, {ReactElement} from "react";
import {Loader} from "../../components/Loader";
import {Table} from "../../components/Table/Table";
import {Dictionary} from "../../components/Dictionary";
import {FormComponent} from "../../components/FormComponent";
import {RightAside} from "../../components/Aside/RightAside";
import {SignTurnRightFill} from "react-bootstrap-icons";
import {SysButton} from "../../components/Elements/SysButton";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {StatusPage} from "../StatusPage";
import {Util} from "../../components/Util";
import {DateTime} from "../../components/ListComponent/DateTime";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";
import {TBody} from "../../components/Table/TBody";

export class TransferProductDetails extends FormComponent {
    protected dictionary: Dictionary = new Dictionary();

    componentDidMount() {
        if (this.user.hasRight('transfer-product/details') === false) {
            return;
        }
        let [section, id] = window.location.pathname.split('/').filter((v: string) => {
            return 0 < v.length
        }).slice(2);

        if (typeof id === 'undefined') {
            id = section;
            section = '';
        }

        this.request.fetch('/transfer-product/' + id, null, {method: 'GET'})
            .then((data: { item: { [key: string]: string }, rights: string[] } | any) => {
                if (!(data.item || null)) {
                    this.setState({
                        code: this.request.getResponseStatus() || 400,
                        message: data.message || 'unknown-error'
                    });
                    return;
                }
                this.setState({
                    id: data.id,
                    item: data.item,
                    rights: data.rights,
                    section: section
                });
            }).catch(error => {
            this.onError(error);
        });
    }

    protected onSuccess(data: any, event: React.FormEvent): any {
        if (data.message) {
            (
                (event.target as HTMLElement).querySelector('form .alert.alert-success') as HTMLElement
            ).innerHTML = this.dictionary.get[data.message];
        }
        (
            (event.target as HTMLElement).querySelector('form .alert.alert-success') as HTMLElement
        ).classList.remove('hide');
        RightAside.reload = true;
    }

    render() {
        if (this.state?.code && this.state?.message) {
            return <StatusPage code={this.state.code} message={this.state.message}/>;
        }
        if (typeof this.state?.item === 'undefined') {
            return <Loader/>;
        }

        let items: any = [];

        for (let i in this.state?.item.items) {
            let elem = this.state?.item.items[i];
            items.push([
                elem.id + " ",
                elem.reference_id,
                elem.reference_no,
                elem.product_id ? Util.link(elem.sku, '/product/details/' + elem.product_id) : elem.sku,
                elem.name,
                <FormattedNumber value={elem.quantity} suffix={this.dictionary.get['pc']}/>,
            ]);
        }

        const saveUrl = "/transfer-product/" + this.state.item.id;

        return (
            <div className="x-form">

                <input type="hidden" name="id" defaultValue={this.state?.item.id || ''}/>

                <div className="row gx-4">
                    {this.state?.item.nfo &&
                        <div className="col-md-12 details">
                            <div className={Util.alertTypeByStatus(this.state.item.status)} role="alert">
                                {this.state?.item.nfo}
                            </div>
                        </div>
                    }

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>
                            {this.dictionary.get['transfer-product-details']}
                            {this.isEditable() && <SysButton onClick={this.editDetails} type={'PencilFill'}
                                                                 text={this.dictionary.get['edit']}/>}
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                {this.getDetails(false)}
                            </table>
                        </div>
                        {this.isEditable() && <div className="hidden">
                            <form onSubmit={this.handleSubmit} action={saveUrl} method="PATCH" id="edit-details"
                                  className="hidden details">

                                <h6>
                                    {this.dictionary.get['edit-transfer-product-details']}
                                    <SignTurnRightFill className="closeRightAside" onClick={RightAside.close}/>
                                </h6>

                                <div className="table-responsive">
                                    <table className="table table-sm align-middle inlineTable">
                                        {this.getDetails(true)}
                                    </table>
                                </div>

                                <FormSubmit aside={true}/>
                            </form>
                        </div>}
                    </div>

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>{this.dictionary.get['fulfillment-info']}</h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                <Table.TBody {...{
                                    data: [
                                        [this.dictionary.get['created_by'], this.state?.item.created_by || ''],
                                        [this.dictionary.get['created_at'], DateTime.create({
                                            value: this.state?.item.created_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['imported_at'], DateTime.create({
                                            value: this.state?.item.imported_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['sync_at'], DateTime.create({
                                            value: this.state?.item.sync_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['shipment_closed_at'], DateTime.create({
                                            value: this.state?.item.shipment_closed_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['receipt_closed_at'], DateTime.create({
                                            value: this.state?.item.receipt_closed_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['closed_at'], DateTime.create({
                                            value: this.state?.item.closed_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['cancelled_at'], DateTime.create({
                                            value: this.state?.item.cancelled_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['updated_by'], this.state?.item.updated_by || ''],
                                        [this.dictionary.get['updated_at'], DateTime.create({
                                            value: this.state?.item.updated_at || '',
                                            inline: true
                                        })],
                                    ]
                                }}/>
                            </table>
                        </div>
                    </div>

                    <div className="col-12">
                        <h6>
                            {this.dictionary.get['transfer-product-items']} -
                            ({items.length} {this.dictionary.get['pc']})
                        </h6>

                        <div className="col-12">
                            <div className="col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2" key={TBody.index++}>
                                {this.dictionary.get['item_count']}&nbsp;
                                <FormattedNumber value={this.state.item.item_count}/>
                                &nbsp;{this.dictionary.get['pc']}
                            </div>
                            <div className="col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2" key={TBody.index++}>
                                {this.dictionary.get['product_count']}&nbsp;
                                <FormattedNumber value={this.state.item.product_count}/>
                                &nbsp;{this.dictionary.get['pc']}
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-hover table-sm align-middle">
                                <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>{this.dictionary.get['reference_id']}</th>
                                    <th>{this.dictionary.get['reference_no']}</th>
                                    <th>{this.dictionary.get['sku']}</th>
                                    <th>{this.dictionary.get['name']}</th>
                                    <th>{this.dictionary.get['quantity']}</th>
                                </tr>
                                </thead>
                                <Table.TBody {...{data: items}}/>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private isEditable(): boolean {
        return false;
    }

    private getStatus(input: boolean, status: any): ReactElement {
        return Util.status(status, {tooltip: this.dictionary.get[status + '-info']});
    }

    private getDetails(input: boolean): ReactElement {
        return (
            <Table.TBody {...{
                data: [
                    [this.dictionary.get['origin'], this.state?.item.service_name || ''],
                    [this.dictionary.get['id'], Util.copyCell(this.state?.item.id || '')],
                    [this.dictionary.get['reference_key'], Util.copyCell(this.state?.item.reference_key || '')],
                    [this.dictionary.get['reference_id'], Util.copyCell(this.state?.item.reference_id || '')],
                    [this.dictionary.get['reference_no'], Util.copyCell(this.state?.item.reference_no || '')],
                    [this.dictionary.get['shipment_no'], Util.copyCell(this.state?.item.shipment_no || '')],
                    [this.dictionary.get['receipt_no'], Util.copyCell(this.state?.item.receipt_no || '')],
                    [this.dictionary.get['warehouse_from_code'], Util.copyCell(this.state?.item.warehouse_from_code || '')],
                    [this.dictionary.get['warehouse_to_code'], Util.copyCell(this.state?.item.warehouse_to_code || '')],
                    [this.dictionary.get['status'], this.getStatus(input, this.state?.item.status)],
                ]
            }}/>
        );
    }

    private editDetails(e: any): void {
        e.preventDefault();
        RightAside.open(document.querySelector('#edit-details') as HTMLElement);
    }
}
